const category = [
    {
        name: 'Danger',
        value: 'bg-danger'
    },
    {
        name: 'Success',
        value: 'bg-success'
    },
    {
        name: 'Primary',
        value: 'bg-primary'
    },
    {
        name: 'Info',
        value: 'bg-info'
    },
    {
        name: 'Dark',
        value: 'bg-dark'
    },
    {
        name: 'Warning',
        value: 'bg-warning'
    },
];

const calendarEvents = [
    {
        id: 1,
        title: 'See john Deo',
        start: new Date(),
        backgroundColor: '#1abc9c'
    },
    {
        id: 2,
        title: 'Meet john deo',
        start: '2019-07-13T12:42:00',
        backgroundColor: '#37cde6'
    },
    {
        id: 3,
        title: 'hey',
        start: '2019-07-13T12:30:00',
        backgroundColor: '#f7b84b'
    },
    {
        id: 4,
        title: 'Buy a Theme',
        start: '2019-07-15T10:42:00',
        backgroundColor: '#3bafda'
    }
];

export { category, calendarEvents };
